import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EE6A32",
      d: "M23.892 18.427a1.468 1.468 0 0 0-.426 1.293l1.186 6.56a1.44 1.44 0 0 1-.6 1.44 1.468 1.468 0 0 1-1.56.107l-5.906-3.08a1.508 1.508 0 0 0-.666-.175h-.362a1.084 1.084 0 0 0-.36.12l-5.906 3.095a1.558 1.558 0 0 1-.947.147 1.482 1.482 0 0 1-1.187-1.695l1.187-6.56a1.492 1.492 0 0 0-.425-1.305l-4.815-4.667a1.44 1.44 0 0 1-.359-1.507 1.497 1.497 0 0 1 1.186-1l6.626-.961a1.483 1.483 0 0 0 1.174-.812l2.92-5.987c.069-.133.158-.256.266-.36l.12-.093a.896.896 0 0 1 .215-.173l.145-.054.227-.093h.561c.502.052.943.352 1.174.8l2.958 5.96c.214.436.628.739 1.107.812l6.627.961c.56.08 1.028.467 1.213 1a1.448 1.448 0 0 1-.387 1.507l-4.986 4.72Z"
    }, null, -1)
  ]))]))
}
export default { render: render }